<script setup lang="ts">
/**
 * L'écran hors offre (S:8362-8367) : ce que lit une entreprise sans l'offre
 * Energy Manager à la place d'une page du module. Jamais une page vide, jamais
 * une redirection muette (T5 §A.1).
 */
// ================================
// IMPORTS
// ================================
import { useI18n } from "vue-i18n"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n()
</script>

<template>
    <!-- ================================ -->
    <!-- COMPOSANT PRINCIPAL -->
    <!-- ================================ -->
    <section
        class="mx-auto mt-8 max-w-2xl rounded-lg border border-surface-200 bg-surface-0 p-6"
        data-test="hors-offre"
    >
        <h2 class="text-lg font-semibold text-surface-900">
            {{ t("alarmesV2.horsOffre.titre") }}
        </h2>
        <p class="mt-2 text-sm text-surface-700">
            {{ t("alarmesV2.horsOffre.texte") }}
        </p>
    </section>
</template>
